import { useState } from 'react';
import { useSuccessReactor, useErrorReactor } from '@livefree/reactive';
import { useRegisterInfo, RegistrationForm } from '@/features/login/registration';
import { Card, CardHeader, CardBody, CardFooter, Alert } from '@heroui/react';
import { SaveButton, ErrorListChip } from '@livefree/react-ui';
import { RoutePaths } from '@/routing/RoutePaths';
import { reactive } from '@/core/reactive/reactive';

export const Register = reactive.component(
  ({ services, monitors }) => {
    const [error, setError] = useState('');
    const { user, handleForm, isValid, errors } = useRegisterInfo();

    useErrorReactor(services.login.register, payload => {
      setError(
        payload.detail || 'Something went wrong, and we were unable to complete the registration',
      );
    });

    useSuccessReactor(services.login.register, payload => {
      const redirectUrl = payload.redirectUrl || RoutePaths().root();
      window.location = redirectUrl;
    });

    return (
      <Card isBlurred className="border-none bg-background/60 dark:bg-default-100/50 max-w-[610px]">
        <CardHeader>Register</CardHeader>
        <CardBody>
          <div className="flex flex-col gap-2">
            {error && <Alert color="danger" title="Error" description={error} />}
            <RegistrationForm onChange={handleForm} />
          </div>
        </CardBody>
        <CardFooter className="flex items-center justify-end gap-1">
          <ErrorListChip errors={errors} />
          <SaveButton
            isDisabled={!isValid}
            isLoading={monitors.register.executing}
            size="sm"
            label="Complete Registration"
            onPress={() => services.login.register(user)}
          />
        </CardFooter>
      </Card>
    );
  },
  {
    name: 'Register',
    monitors: services => [services.login.register],
  },
);
